// ===========================================
// i18n CONFIGURATION
// ===========================================

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { i18nConfig } from '@/config';

import { isAdminDomain } from '@/utils/domain';

// Determine which namespaces to load based on domain
const isPublic = !isAdminDomain();
let namespaces = [...i18nConfig.namespaces];

if (isPublic) {
  // Filter out namespaces that are managed by CMS or Admin-only to avoid 404s
  const cmsNamespaces = ['packages', 'excursions', 'blog', 'destinations', 'about', 'admin', 'errors', 'validation'];
  namespaces = namespaces.filter(ns => !cmsNamespaces.includes(ns));
}

/**
 * Initialize i18next with all configurations
 */
i18n
  // Load translation using http backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: i18nConfig.fallbackLanguage,

    // Default namespace
    defaultNS: i18nConfig.defaultNamespace,
    ns: namespaces,

    // Debug mode (limit to dev and not distracting)
    debug: false,

    // Detection options — path is primary so /:lang/page URLs are canonical
    detection: {
      order: ['path', 'localStorage', 'cookie', 'navigator'],
      lookupFromPathIndex: 0,
      lookupCookie: 'i18next',
      lookupLocalStorage: 'tt_language',
      caches: ['cookie', 'localStorage'],
    },

    // Backend options (loading translation files)
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    // React options
    react: {
      useSuspense: true,
    },
  });

export default i18n;
